import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import LogRocket from 'logrocket';

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// putting freshdesk icon on a lower position for toasters
try {
  document.querySelector(
    "#freshworks-container"
  ).childNodes[0].childNodes[0].style.bottom = 0;
} catch (err) {}

LogRocket.init('hmdiky/schint');
